import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import OrderCreateSummary from './OrderCreateSummary';
import AddNoteOrder from './AddNoteOrder';
import ShopAvailableCoupon from '../../shop/ShopAvailableCoupon';
import Notifications from '../../../services/notifications';
import OrderProp from '../../shop/propTypes/orderProp';
import { compose } from '../../../services/utilityFunctions';
import withCSRF from '../../../commonComponents/withCSRF';

function OrderCreateFooter(props) {
  const { order, products, _csrf, t, onCouponSelection, onCoinsSelection } =
    props;

  const [coupons, setCoupons] = useState(null);

  useEffect(() => {
    setCoupons(null);
  }, [order?.seller?._id]);

  useEffect(() => {
    if (products?.length === 0) {
      setCoupons(null);
    }
  }, [products]);

  useEffect(() => {
    if (products.length > 0 && order?.seller) {
      let availableCouponsReqPath =
        '/api/discount/coupon/available?moduleType=marketPlace';

      if (order.currency) {
        availableCouponsReqPath += `&currency=${order.currency}`;
      }
      if (order?.seller.shippingCountry) {
        availableCouponsReqPath += `&country=${order?.seller.shippingCountry}`;
      }
      if (order?.seller?._id) {
        availableCouponsReqPath += `&user=${order?.seller._id}`;
      }

      axios
        .post(
          availableCouponsReqPath,
          {
            marketProductVariations: products?.map(product => {
              if (product?.isPack) {
                if (product.packType !== 'normal') {
                  return {
                    packProduct: product._id,
                    quantity: product.quantityToOrder,
                    type: 'pack_advanced',
                    packVariations: product?.packVariations?.map(variation => ({
                      variation: variation._id || variation?.variation,
                      quantity: variation.quantity,
                      stockQuantity: variation.stockQuantity,
                    })),
                  };
                }
                return {
                  packProduct: product._id,
                  quantity: product.quantityToOrder,
                  type: 'pack',
                };
              }

              return {
                variation: product._id,
                quantity: product.quantityToOrder,
                type: 'product',
              };
            }),
          },
          {
            headers: {
              'Accept-Version': '1.0.0',
              'X-Gamification-API': 'Games',
              'X-CSRF-Token': _csrf,
              _csrf,
            },
          },
        )
        .then(({ data: response }) => {
          setCoupons(response.data);
        })
        .catch(err => {
          Notifications.showErrorFromRequest(err, 'error_getAvailableCoupons');
          console.log(err);
        });
    }
  }, [products, order?.seller?._id]);

  return (
    <div
      id="orderCreateFooter"
      className="order-footer-wrapper m-portlet m-portlet--mobile"
    >
      <div style={{ display: 'flex', flexDirection: 'column', flex: 6 }}>
        {coupons?.length > 0 && (
          <div className="coupons-choose">
            <div className="title">
              <h3>{t('shop.cart.apply_discount')}</h3>
              <p>{t('shop.cart.choose_coupon_reward')}</p>
            </div>
            {coupons.map(coupon => (
              <ShopAvailableCoupon
                key={coupon._id}
                coupon={coupon}
                onClick={c => onCouponSelection(c.code)}
                selectedCoupon={order?.discount}
                selectedCoins={order?.isPaidWithCoins ? 'COINS' : null}
                handleCoinsClick={c =>
                  onCoinsSelection(
                    order?.isPaidWithCoins ? false : c.code === 'COINS',
                  )
                }
              />
            ))}
          </div>
        )}
        <AddNoteOrder {...props} />
      </div>
      <OrderCreateSummary {...props} />
    </div>
  );
}

OrderCreateFooter.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  order: PropTypes.shape(OrderProp.propType).isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      product: PropTypes.string.isRequired,
      quantity: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onCouponSelection: PropTypes.func.isRequired,
  onCoinsSelection: PropTypes.func.isRequired,
};

export default compose(translate, withCSRF)(OrderCreateFooter);
